'use strict';

/*global initialize*/

function BasicBarcodes(containerId) {
  this.containerId = containerId;
  this.isSubmited = false;
  this.$container = null;
  this.$form = null;
  this.isEnabledOnAfterAddItem = true;

  this.init();
}

BasicBarcodes.prototype = $.extend({}, {
  constructor: 'BasicBarcodes',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    _this.$form.on('click', '.barcodes-items__remove-item', function () {
      _this.removeItem($(this).closest('tr'));
      return false;
    });

    _this.$form.on('change', '.barcode', function () {
      if (!_this.existsItem($(this).val())) {
        _this.addItem($(this).val());
      } else {
        _this.emptyForm();
      }

      return false;
    });

    _this.$form.on('submit', function () {
      if (!_this.isSubmited) {
        return false;
      }

      return true;
    });

    _this.$form.on('click', '.submit-form', function () {
      _this.submitForm();

      return false;
    });

    _this.$form.on('click', '.barcodes__set-option', function () {
      _this.setOption($(this).data('option'));

      return false;
    });

  },

  //----------------------------------------------------------------------------

  onAfterAddItem: function onAfterAddItem(/*$row*/) {
    var _this = this;

    return _this;
  },

  removeItem: function removeItem($row) {
    var _this = this;

    $row.remove();

    _this.emptyForm();

    return _this;
  },

  addItem: function addItem(barcode) {
    var _this = this;

    var $wrapper = _this.$form.find('.barcodes__items');

    var prototypeForm = $wrapper.data('prototype');
    var index = parseInt($wrapper.data('last_index')) + 1;
    var newForm = prototypeForm.replace(/__name__/g, index);
    var $newCollectionItem = $(newForm);
    $wrapper.data('last_index', index);

    $wrapper.find('tbody').append($newCollectionItem);
    initialize($newCollectionItem);

    $newCollectionItem.find('input[name$="[Barcode]"]').val(barcode);
    $newCollectionItem.find('.barcodes-items__barcode-title').text(barcode);

    if (_this.isEnabledOnAfterAddItem) {
      _this.onAfterAddItem($newCollectionItem);
    }

    _this.emptyForm();

    return $newCollectionItem;
  },

  existsItem: function existsItem(barcode) {
    var _this = this;

    var $wrapper = _this.$form.find('.barcodes__items');

    return $wrapper.find('input[name$="[Barcode]"][value="' + barcode + '"]').length > 0;
  },

  emptyForm: function emptyForm() {
    var _this = this;

    var $barcode = _this.$form.find('.barcode');

    $barcode.val('').focus();

    return _this;
  },

  submitForm: function submitForm() {
    var _this = this;

    if (!_this.isSubmited) {
      if (_this.isFormValid()) {
        _this.isSubmited = true;

        _this.$form.submit();
      }
    }

    return _this;
  },

  setOption: function setOption(option) {
    var _this = this;

    _this.$form.find('input[name$="[Option]"]').val(option);

    _this.submitForm();

    return _this;
  },

  isFormValid: function isFormValid() {
    var _this = this;

    var ret = true;

    _this.$form.find('.barcode').parent().removeClass('has-error');

    var $wrapper = _this.$form.find('.barcodes__items');

    if (!$wrapper.find('.barcodes-items__barcode-title').length) {
      _this.$form.find('.barcode').parent().addClass('has-error');

      ret = false;
    }

    return ret;
  },

  //----------------------------------------------------------------------------

  initForm: function initForm() {
    var _this = this;

    _this.isSubmited = false;
    _this.$form = _this.$container.find('form');

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerId);
    _this.initForm();

    _this.registerCallbacks();

    return _this;
  }
});
